
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 16 16"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M7.997 0a8 8 0 11.005 16 8 8 0 01-.005-16zm0 .909C4.087.91.907 4.092.909 8.002c.001 3.91 3.183 7.09 7.093 7.089 3.91-.001 7.09-3.183 7.089-7.093-.002-3.91-3.184-7.09-7.094-7.089zm.033 10.552c.286 0 .523.094.711.28a.93.93 0 01.281.682.96.96 0 01-.28.68.936.936 0 01-.71.297.96.96 0 01-.705-.288.929.929 0 01-.289-.674c0-.266.094-.495.281-.688a.954.954 0 01.711-.29zm.031-8.788c.417 0 .807.059 1.17.177.362.119.682.294.96.526.278.232.497.518.656.858.16.34.24.733.24 1.177 0 .316-.036.592-.105.829a2.5 2.5 0 01-.29.644 2.893 2.893 0 01-.455.54 14.84 14.84 0 01-.376.342l-.48.415a7.924 7.924 0 00-.23.213c-.14.133-.249.269-.328.407-.08.139-.137.292-.17.459a3.114 3.114 0 00-.053.622v.518H7.2v-.71c0-.257.024-.488.074-.696.05-.207.121-.394.216-.562.094-.168.208-.328.342-.482.134-.152.285-.308.454-.466l.551-.518c.218-.188.4-.393.544-.615.143-.222.215-.505.215-.851 0-.474-.15-.851-.454-1.132-.304-.281-.693-.422-1.17-.422-.497 0-.893.159-1.19.475-.299.315-.473.7-.522 1.154l-1.43-.162c.06-.424.183-.807.372-1.147a3.02 3.02 0 01.707-.867c.283-.236.608-.417.976-.54a3.65 3.65 0 011.176-.186z","fill-rule":"evenodd","clip-rule":"evenodd"}})])
          )
        }
      }
    